import React, { useState } from 'react';
import {Box,Tab,Grid} from '@mui/material';
import {TabContext,TabList,TabPanel} from '@mui/lab';
import MoreDetails from 'components/moreDetails/MoreDetails';
import MatrixDriverVendor from 'pages/vendor/driverVendor/MatrixDriverVendor';
import VehicleInfo from 'pages/vendor/driverVendor/VehicleInfo';
import { subVendorVechileMatrix } from './SubVendorVechileData';


function SubVendorVechileTab(props) {

  const handleChange = (event, newValue) => {
    props?.onTabChange(newValue)
  };


  return (
    <Grid container>
      <Grid item className="tabContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item >
                <TabList
                  className='minHeight32'
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'white' }
                  }}
                >
                  <Tab label="Matrix" value="1" className="tabStyle" />
                  <Tab label="More Details" value="2" className="tabStyle" />
                  <Tab label="Vehicle Info" value="3" className="tabStyle" />
                </TabList>
              </Grid>

              <Grid item >
              </Grid>
            </Grid>
            <TabPanel
              value="1"
              className="tabPanelStyle"
            >
              <MatrixDriverVendor  matrix={subVendorVechileMatrix(props?.vehicleMatrixData)}/>
            </TabPanel>
            <TabPanel value="2" className="tabPanelStyle">
              <MoreDetails details={props?.vehicleMoreData}/>
            </TabPanel>
            <TabPanel value="3">
              <VehicleInfo vehicleInfo={props?.vehicleInfo} vehicleImage={props?.vehicleImage} amenitiesVehicle={props?.amenitiesVehicle} editButton={props?.editButton}/>
            </TabPanel>
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}

export default SubVendorVechileTab;
